import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/shared/ui/alert-dialog'
import { useTranslation } from 'react-i18next';

export default function RecordingDiscardDialog({
  trigger,
  open,
  onOpenChange,
  onConfirm,
  contentClassName = 'z-[60]',
}) {
  const { t } = useTranslation();

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      {trigger ? <AlertDialogTrigger asChild className="w-full">{trigger}</AlertDialogTrigger> : null}
      <AlertDialogContent className={contentClassName}>
        <AlertDialogHeader>
          <AlertDialogTitle>{t('reports.generate.record.sure')}</AlertDialogTitle>
          <AlertDialogDescription>
            {t('reports.generate.record.lostWarning')}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="flex sm:justify-start">
          <AlertDialogCancel className="w-full">{t('common.no')}</AlertDialogCancel>
          <AlertDialogAction className="w-full" onClick={onConfirm}>
            {t('common.yes')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
